/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useCarousel } from "./CarouselProvider.tsx";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Fab from "@mui/material/Fab";
import { SxProps } from "@mui/material";
import { Theme } from "@mui/system";
import { useEffect, useState } from "react";

type CarouselArrowProps = {
  type: "previous" | "next"
  sx?: SxProps<Theme>,
  hideIfDisabled?: boolean
}
export const CarouselArrow = ({ type, sx, hideIfDisabled }: CarouselArrowProps) => {
  const { carouselApi } = useCarousel();
  const [canScroll, setCanScroll] = useState(false);

  useEffect(() => {
    if (!carouselApi) {
      return;
    }

    const handleChange = () => {
      setCanScroll((type === "previous" ? carouselApi?.canScrollPrev() : carouselApi?.canScrollNext()) ?? false);
    };

    carouselApi?.on("scroll", handleChange);
    carouselApi?.on("slidesChanged", handleChange);

    handleChange();

    return () => {
      carouselApi?.off("scroll", handleChange);
      carouselApi?.off("slidesChanged", handleChange);
    };
  }, [type, carouselApi]);

  return (
    <Fab
      size={"medium"}
      sx={{ cursor: "pointer", display: hideIfDisabled && !canScroll ? "none" : null, ...sx }}
      aria-label={type === "previous" ? "Vorheriges Slide" : "Nächstes Slide"}
      onClick={() => {
        type === "previous" ? carouselApi?.scrollPrev() : carouselApi?.scrollNext();
      }}
      disabled={!canScroll}
    >
      {type === "previous" ? <ChevronLeft /> : <ChevronRight />}
    </Fab>
  );
};
